// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2jbQf","modalForm":"UpgradeEpcsModal_modalForm__3PA_j","modalFooter":"UpgradeEpcsModal_modalFooter__3m5_o"};